run();



// WEBPACK FOOTER //
// ../../../../../root/api-docs/assets/js/api-diff-tool/script-api-diff-runner.js